import type { ApiError } from "@entrilia/shared/api/types";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import { logError } from "@entrilia/shared/logging";
import type { ReportRow, TabularReport } from "../../../api/types/widgetTypes";
import NoDataResult from "../../common/NoDataResult";
import TabularReportList from "../../common/reports/mobile/TabularReportList";

interface Props {
  report: TabularReport | undefined;
  rows: ReportRow[];
  loading: boolean;
  columnsLimit?: number;
  noDataText?: string;
  fetchError?: ApiError;
}

const WidgetMobileContent = ({ report, rows, loading, columnsLimit, noDataText, fetchError }: Props) => {
  if (fetchError) {
    logError(fetchError, "[WidgetMobileContent] fetchError");
    return <DataLoadingFailed />;
  }

  if (noDataText) {
    return <NoDataResult text={noDataText} />;
  }

  if (report === undefined) {
    return <InlineLoader />;
  }

  return (
    <TabularReportList
      columns={report.columns}
      rows={rows}
      columnsLimit={columnsLimit}
      loading={loading}
      detailColumns={report.detailColumns}
    />
  );
};

export default WidgetMobileContent;
